import { publishReplay, refCount, map } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { HttpClientService } from '../httpClient/httpclient.service';
import { Observable } from 'rxjs/Observable';
import { ClusterHead } from '../../models/loyalty-cluster.model';
import { ListMetadata } from '../../models/list-metadata.model';
import { AuthService } from './../user/auth.service';
import { MessageService } from 'primeng/api';
import { TranslateService } from '@ngx-translate/core';

@Injectable()
export class LoyaltyClusterHeadService {

  public baseUrl = '/koncentro-loyalty';
  public clusterId: string = null;
  private cachedFields: Observable<any>;

  constructor(
    private http: HttpClientService,
    private authService: AuthService,
    private messageService: MessageService,
    private translateService: TranslateService
  ) { }
  list(
    offset: number | null = null,
    limit: number | null = null,
    search?: Array<{ key: string; value: string }>,
    globalSearch?: string,
    sort?: string,
    sort_dir?: number
  ): Observable<{ data: any; metadata: ListMetadata }> {
    const params = HttpClientService.buildListParams(offset, limit, search, globalSearch, sort, sort_dir);
    const paramsString = params.toString().replace(/\+/g, '%2B');
    if(this.clusterId)
     return this.http.getPaged(this.baseUrl + '/cluster/' + this.clusterId + '/head_complete?' + paramsString.toString());
  }

  update(clusterId: string, clusterHeadId: string, clusterHead: ClusterHead, modifyCustomers: boolean = false): Observable<ClusterHead> {
    let url = `${this.baseUrl}/cluster/${clusterId}/head/${clusterHeadId}`;
    if (modifyCustomers) {
      url += '?modify_customers=true';
    }
    return this.http.put(url, clusterHead);
  }

  create(clusterId, clusterHead: ClusterHead): Observable<ClusterHead> {
    return this.http.post(this.baseUrl + '/cluster/' + clusterId + '/head/', clusterHead);
  }

  remove(clusterId, clusterHeadId): Observable<ClusterHead> {
    return this.http.delete(this.baseUrl + '/cluster/' + clusterId + '/head/' + clusterHeadId);
  }

  getClusterHeadList(clusterHeadId?) {
    if (clusterHeadId) {
      return this.http.get(this.baseUrl + '/cluster/getClusterHeadList?exclude=' + clusterHeadId);
    } else {
      return this.http.get(this.baseUrl + '/cluster/getClusterHeadList');
    }
  }
  getFields() {
    if (!this.cachedFields) {
      this.cachedFields = this.http.get(`${this.baseUrl}/schema/ClusterHeadDto`).pipe(
        publishReplay(1), // this tells Rx to cache the latest emitted
        refCount() // and this tells Rx to keep the Observable alive as long as there are any Subscribers
      )
    }
    return this.cachedFields;
  }

  checkClusterHead(conversionCode, touchpointId, startDate, endDate) {
    return this.http.get(`${this.baseUrl}/cluster/getClusterHeadList?conversionCode=${conversionCode}&touchpointId=${touchpointId}&startDate=${startDate}&endDate=${endDate}`);
  }

  saveAllClusterHead(clusterId, clusterHeads: Array<ClusterHead>,): Observable<ClusterHead> {
    return this.http.post(this.baseUrl + '/cluster/' + clusterId + '/saveAllClusterHead/', clusterHeads);
  }

  emptyCustomers(clusterHeadId, payload: any): Observable<ClusterHead> {
    return this.http.post(this.baseUrl + '/cluster/head/' + clusterHeadId + '/empty', payload);
  }

  exportCustomers(clusterHeadId, activeOnly: boolean): Observable<string> {
    return this.http.get(this.baseUrl + '/cluster/' + clusterHeadId + '/exportClusterHeadCustomers?active_only=' + activeOnly);
  }

  downloadFile(filename: string): Observable<Blob> {
    const requestBody = { 'filename': filename };
    const userCompany = this.authService.user.selectedCompany.toString();
    const token = `Bearer ${this.authService.user.token}`;
    const language = this.authService.sessionHelper.selectedLanguage;
    const requestHeaders = {
      'Accept-Company': userCompany,
      'Content-Type': 'application/json',
      'Authorization': token,
      'Accept-Language': language
    };
    return this.http.post(
      '/koncentro-loyalty/download',
      requestBody,
      {
        headers: requestHeaders,
        responseType: 'blob'
      }
    ).catch((err) => {
      console.error('loy downloadFile' + JSON.stringify(err));
      this.messageService.add({
        severity: 'error',
        summary: this.translateService.instant('common.error'),
        detail: this.translateService.instant('cluster_head.error_export')
      });
      return Observable.throw(err);
    });
  }

  countCustomers(clusterHeadId, endDate?: string): Observable<ClusterHead> {
    let url = `${this.baseUrl}/cluster/countClusterHeadCustomers?cluster_head_id=${clusterHeadId}`;
    if (endDate) {
      url += `&end_date=${endDate}`;
    }
    return this.http.get(url);
  }
}



// WEBPACK FOOTER //
// ./src/app/services/loyalty/loyalty-cluster-head.service.ts